export default "__VITE_ASSET__DBqhWzxb__"